import { Calendar, ChevronRight, Heart, MapPin, Settings, Shield, Sparkles } from 'lucide-react';

export default function ViewCreer() {
  return (
    <div className='grid md:grid-cols-2 gap-10 items-start demo-view-enter'>
      {/* Left */}
      <div className='space-y-6'>
        <div className='inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/20 px-3 py-1.5 rounded-full'>
          <Sparkles className='w-3.5 h-3.5 text-emerald-500 dark:text-emerald-400' />
          <span className='text-xs font-bold text-emerald-600 dark:text-emerald-400'>
            Fini les affiches + inscriptions manuelles
          </span>
        </div>

        <div>
          <h3 className='text-2xl font-black text-slate-900 dark:text-white mb-2'>Créez votre concours</h3>
          <p className='text-slate-500 dark:text-slate-400 text-sm leading-relaxed'>
            Paramétrez format, niveaux, dotation, prix, quotas et horaires. Les pages concours, listes et exports se
            génèrent automatiquement.
          </p>
        </div>

        <div className='bg-slate-100 border border-slate-200 dark:bg-slate-800/80 dark:border-slate-700 rounded-2xl p-4 space-y-3'>
          <div className='flex items-center justify-between'>
            <div className='flex items-center gap-2 text-xs font-black text-slate-600 dark:text-slate-300'>
              <Settings className='w-4 h-4 text-blue-600 dark:text-blue-400' />
              Paramètres clés
            </div>
            <span className='text-[10px] text-slate-500 dark:text-slate-400'>Pré-remplis</span>
          </div>

          <div className='grid grid-cols-2 gap-3 text-xs'>
            {[
              { label: 'Format', value: 'Doublette' },
              { label: 'Niveau', value: 'Régional' },
              { label: 'Prix', value: '30 €' },
              { label: 'Quotas', value: '128 équipes' },
            ].map(({ label, value }) => (
              <div
                key={label}
                className='bg-white border border-slate-200 dark:bg-slate-900/60 dark:border-slate-800 rounded-xl p-3'
              >
                <p className='text-[10px] font-black text-slate-500 uppercase tracking-widest mb-1'>{label}</p>
                <p className='font-bold text-slate-900 dark:text-white'>{value}</p>
              </div>
            ))}
          </div>
        </div>

        <div className='grid grid-cols-3 gap-3 pt-2'>
          {[
            { v: '3 min', l: 'mise en ligne', c: 'text-blue-600 dark:text-blue-400' },
            { v: '0', l: 'erreur saisie', c: 'text-emerald-600 dark:text-emerald-400' },
            { v: '1', l: 'page concours', c: 'text-amber-600 dark:text-amber-400' },
          ].map(({ v, l, c }) => (
            <div
              key={l}
              className='bg-slate-50 border border-slate-200 dark:bg-slate-900/60 dark:border-slate-800 rounded-2xl p-4 text-center'
            >
              <p className={`text-xl font-black ${c}`}>{v}</p>
              <p className='text-[10px] text-slate-500 mt-0.5'>{l}</p>
            </div>
          ))}
        </div>

        <div className='flex items-start gap-2 text-xs text-slate-500 bg-slate-50 border border-slate-200 dark:bg-slate-900/50 dark:border-slate-800 rounded-xl px-4 py-3'>
          <Shield className='w-3.5 h-3.5 shrink-0 mt-0.5' />
          <span>Les paiements sont gérés par Stripe. Les confirmations sont déclenchées via webhooks.</span>
        </div>
      </div>

      {/* Right — cards */}
      <div className='space-y-3'>
        <div className='bg-blue-50/60 border border-blue-200/60 dark:bg-slate-800/60 dark:border-blue-500/30 rounded-2xl p-5 hover:border-blue-400 dark:hover:border-blue-500/60 transition cursor-pointer'>
          <div className='flex items-start gap-3 mb-4'>
            <div className='flex-1'>
              <div className='flex gap-1.5 mb-1.5'>
                <span className='bg-amber-400/10 border border-amber-400/20 text-amber-600 dark:text-amber-400 text-[9px] font-black px-2 py-0.5 rounded-md uppercase tracking-wider'>
                  Dotation 3 000 €
                </span>
                <span className='bg-blue-500/10 border border-blue-500/20 text-blue-600 dark:text-blue-400 text-[9px] font-bold px-2 py-0.5 rounded-md uppercase'>
                  Régional
                </span>
              </div>
              <p className='font-bold text-slate-900 dark:text-white text-sm'>Grand Prix Pétanque d'Été — Gerland</p>
              <div className='flex items-center gap-4 mt-1.5 text-slate-500 dark:text-slate-400 text-xs'>
                <span className='flex items-center gap-1'>
                  <MapPin className='w-3 h-3' />
                  Lyon, 69
                </span>
                <span className='flex items-center gap-1'>
                  <Calendar className='w-3 h-3' />
                  13 Juin 2026
                </span>
              </div>
            </div>
            <button className='p-1.5 text-slate-400 dark:text-slate-600 hover:text-red-400 transition'>
              <Heart className='w-4 h-4' />
            </button>
          </div>

          <div className='flex items-center gap-4'>
            <div className='flex-1'>
              <div className='flex justify-between text-xs mb-1'>
                <span className='text-slate-500 dark:text-slate-400'>Inscriptions ouvertes</span>
                <span className='font-bold text-emerald-600 dark:text-emerald-400'>Oui</span>
              </div>
              <div className='h-1.5 bg-slate-200 dark:bg-slate-700 rounded-full overflow-hidden'>
                <div className='h-full bg-linear-to-r from-blue-500 to-emerald-500 rounded-full w-[65%]' />
              </div>
            </div>
            <span className='bg-blue-100 border border-blue-200 text-blue-600 dark:bg-blue-600/20 dark:border-blue-500/30 dark:text-blue-300 text-[10px] px-2.5 py-1 rounded-lg font-bold shrink-0'>
              128 places
            </span>
          </div>
        </div>

        <div className='bg-white border border-slate-200 dark:bg-slate-800/50 dark:border-slate-700 rounded-2xl p-5 hover:border-slate-300 dark:hover:border-slate-600 transition cursor-pointer'>
          <div className='flex items-center justify-between'>
            <div>
              <span className='bg-emerald-500/10 border border-emerald-500/20 text-emerald-600 dark:text-emerald-400 text-[9px] font-bold px-2 py-0.5 rounded-md uppercase'>
                Page concours publiée
              </span>
              <p className='mt-2 font-bold text-slate-900 dark:text-white text-sm'>Lien partageable · SEO prêt</p>
              <p className='text-xs text-slate-500 dark:text-slate-400 mt-1'>URL publique + inscription en ligne</p>
            </div>
            <ChevronRight className='w-5 h-5 text-slate-400 dark:text-slate-600' />
          </div>
        </div>

        <p className='text-center text-slate-500 dark:text-slate-600 text-xs pt-1'>+ 12 concours gérés</p>
      </div>
    </div>
  );
}
